/**
 * Floating anonymous CTA above the planning composer (ChatGPT-style pattern, TMOS theme).
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/state/language/LanguageProvider';

export interface PlanningAnonAuthBarProps {
  embedded?: boolean;
}

export const PlanningAnonAuthBar: React.FC<PlanningAnonAuthBarProps> = ({ embedded }) => {
  const { t } = useLanguage();

  return (
    <div
      className={
        embedded
          ? 'mb-1.5 flex flex-wrap items-center justify-between gap-2 rounded-full border border-gray-400/40 bg-white/95 px-3 py-1.5 shadow-sm'
          : 'mb-1.5 flex flex-wrap items-center justify-between gap-2 rounded-full border border-[var(--color-border)] bg-[var(--color-surface-bg)] px-3 py-1.5 shadow-sm'
      }
      role="region"
      aria-label={t('planning.anonCtaAria')}
    >
      <p
        className={
          embedded
            ? 'min-w-0 flex-1 text-sm text-gray-700'
            : 'min-w-0 flex-1 text-sm text-[var(--color-surface-text)]'
        }
      >
        {t('planning.anonCtaMessage')}
      </p>
      <div className="flex shrink-0 items-center gap-2">
        <Link
          to="/"
          className={
            embedded
              ? 'rounded-full bg-gray-900 px-3 py-1.5 text-sm font-medium text-white hover:bg-gray-800'
              : 'rounded-full bg-[var(--color-primary-bg)] px-3 py-1.5 text-sm font-medium text-[var(--color-primary-text)] hover:opacity-90'
          }
        >
          {t('planning.anonLogIn')}
        </Link>
        <Link
          to="/register"
          className={
            embedded
              ? 'rounded-full border border-gray-400 px-3 py-1.5 text-sm font-medium text-gray-800 hover:bg-gray-100'
              : 'rounded-full border border-[var(--color-border)] px-3 py-1.5 text-sm font-medium text-[var(--color-surface-text)] hover:bg-[var(--color-surface-hover)]'
          }
        >
          {t('planning.anonSignUp')}
        </Link>
      </div>
    </div>
  );
};
